import { render, staticRenderFns } from "./Mouse.vue?vue&type=template&id=08029572&scoped=true"
import script from "./Mouse.vue?vue&type=script&lang=js"
export * from "./Mouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08029572",
  null
  
)

export default component.exports